/**
 * Zeigt den AudioText an
 * @class directive_v3sAudiotext
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').directive('v3sAudiotext', ["v3sSubtitleService", "v3sMediaService", "v3sServiceFinder", function (v3sSubtitleService, v3sMediaService, v3sServiceFinder) {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        scope: {
            id: '@',
            v3sFile: '@'
        },
        transclude:true,
        template: '<div class="v3s-subtitle-nav v3s-icon v3s-icon-popup-prev"></div><div class="subtitle-container" ng-transclude></div><div class="v3s-subtitle-nav v3s-icon v3s-icon-popup-next"></div>',
        link: function (scope, element, attrs, docCtrl) {
            var v3sGsapService = v3sServiceFinder.get("v3sGsapService");

            //Die Timelines
            var tl;
            var subtitleTl;

            //Breaks führen zu fehlern
            element.html(element.html().replace(/<\/?break[^>]*>/g, ""));


            //Der Text
            var splittext = element.html();

            //Element id finden
            var parentId = element.parent().attr("id");


            //media
            var media = v3sMediaService.getMedia(parentId);
            if(!!parentId) element.attr("id", "audiotext_" + parentId);

            //Anmelden beim SubtitleService
            v3sSubtitleService.addSubtitleElement(element.clone());
        }
    }
}]);
